import { prod as auth0Prod } from './auth0.config';
import { Environment } from './environment.d';

export const environment: Environment = {
  production: true,
  apiProjectName: 'third_parent', // a vg-nél '', a többi produkciónál majd a projekt neve
  htmlTitlePrefix: 'The Third Parent // ',
  ...auth0Prod,
};
